import { BaseComponent } from "utils/base-component"
import { openWebcamPopup, WebcamPopupData } from "components/webcam-popup"
import "./resort-webcams.scss"
import "./static/icon--archive.svg"
import "./static/icon--panorama.svg"
import "./static/icon--player.svg"
import "./static/webcam_placeholder.jpg"

export class ResortWebcams extends BaseComponent {
  static cssClass = "resort-webcams"

  init() {
    this.bindThumbnailFallbacks()

    this.elements("preview-button").forEach((button) => {
      const element = button.element as HTMLButtonElement

      element.addEventListener("click", (event) => {
        const popupData = element.dataset.webcamPopup
        if (!popupData) return

        event.preventDefault()
        openWebcamPopup(JSON.parse(popupData) as WebcamPopupData)
      })
    })
  }

  private bindThumbnailFallbacks() {
    const imageHiddenClass = `${ResortWebcams.cssClass}__image--hidden`
    const noPhotoHiddenClass = `${ResortWebcams.cssClass}__no-photo--hidden`

    this.root.querySelectorAll(`.${ResortWebcams.cssClass}__item-image`).forEach((container) => {
      const image = container.querySelector(
        `.${ResortWebcams.cssClass}__image`,
      ) as HTMLImageElement | null
      const noPhoto = container.querySelector(
        `.${ResortWebcams.cssClass}__no-photo`,
      ) as HTMLElement | null

      if (!image || !noPhoto) return

      const renderFallback = () => {
        image.classList.add(imageHiddenClass)
        noPhoto.classList.remove(noPhotoHiddenClass)
      }

      const renderImage = () => {
        image.classList.remove(imageHiddenClass)
        noPhoto.classList.add(noPhotoHiddenClass)
      }

      image.addEventListener("load", renderImage)
      image.addEventListener("error", renderFallback)

      if (image.complete) {
        if (image.naturalWidth > 0) {
          renderImage()
        } else {
          renderFallback()
        }
      }
    })
  }
}
